import { CircularProgress, Paper } from '@mui/material'
import s from './VoucherInfo.modules.scss'
import { KeyValuePairs } from 'components/core-ui/KeyValuePairs'
import { formatUIDateTime } from 'utils/helpers'
import { VoucherInfoResponse } from 'components/cora-sgr-coupons/interfaces'
import { FC } from 'react'
import { Divider, IconButton } from '@fullscreendigital/carrefour-dex-fe'
import { Icon } from 'components/core-ui/Icon'
import { Check } from '@mui/icons-material'

interface VoucherInfoProps {
  voucherInfo: VoucherInfoResponse
  onSubmitVoucher: () => void
  isLoadingValidateVoucher: boolean
}

const VoucherInfo: FC<VoucherInfoProps> = props => {
  const { voucherInfo, onSubmitVoucher, isLoadingValidateVoucher } = props

  return (
    <Paper className={s.voucherInfoContainer}>
      <div className={s.infoContainer}>
        <div className={s.price}>
          {voucherInfo.deposit}&nbsp;{voucherInfo.currency}
        </div>
        <IconButton
          onClick={onSubmitVoucher}
          label="Utilizeaza voucher"
          variant="contained"
          endIcon={
            isLoadingValidateVoucher ? (
              <CircularProgress
                color="primary"
                style={{ color: 'white', width: '20px', height: '20px' }}
                disableShrink
              />
            ) : (
              <Check />
            )
          }
          disabled={voucherInfo.isUsed !== false || isLoadingValidateVoucher}
          sx={voucherInfo.isUsed === false && !isLoadingValidateVoucher ? {} : { opacity: 0.5 }}
        />
      </div>
      <Divider component="div" />
      <div className={s.infoContainer}>
        <span className={s.firstCode}>
          <span className={s.lightText}>Cod Voucher:</span> <strong>{voucherInfo.barcode}</strong>
        </span>
        <span className={s.secondCode}>
          <span className={s.lightText}>Cod RVM:</span> <strong>{voucherInfo.rvm}</strong>
        </span>
        <KeyValuePairs
          pairs={[
            { key: 'ID magazin:', value: voucherInfo.storeId },
            { key: 'ID casa de marcat:', value: voucherInfo.cashRegisterId },
            { key: 'Data emitere:', value: formatUIDateTime(voucherInfo.receivedResponse) },
            { key: 'Data expirare:', value: formatUIDateTime(voucherInfo.reservedUntil) },
            { key: 'Status:', value: voucherInfo.isUsed ? 'Utilizat' : 'Neutilizat' }
          ]}
          columns={2}
          className={s.stockInfo}
        />
      </div>
    </Paper>
  )
}

export default VoucherInfo
